module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 topic-header dash-bg-color-skin-light-40"
  }, [_c('p', [_vm._v(_vm._s(_vm.knowledge.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 detail-knowledge"
  }, [_vm._v(_vm._s(_vm.knowledge.content))])]), _vm._v(" "), _c('div', {
    staticClass: "row attachment"
  }, [_c('div', {
    staticClass: "col-xs-2 att-ico"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.knowledge.file_path),
      expression: "knowledge.file_path"
    }],
    staticClass: "fa fa-paperclip dash-color-skin",
    attrs: {
      "href": _vm.knowledge.file_path,
      "download": "",
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 att-ico"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.knowledge.link),
      expression: "knowledge.link"
    }],
    staticClass: "fa fa-link dash-color-skin",
    attrs: {
      "href": 'http://' + _vm.knowledge.link,
      "target": "_blank",
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "row writer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 text"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.knowledge.coduser) + " \n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "row writer"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.knowledge.dteupd) + " \n\t\t\t\t")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 ico"
  }, [_c('i', {
    staticClass: "fa fa-user-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 ico"
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0352c339!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/knowledge/detail.vue
// module id = 3507
// module chunks = 1